import { useState } from "react";
import CustomButton from "../../../common/CustomButton";
import TextOptionTile from "../../../common/TextOptionTile";

import { weekFull } from "../../../constants";

function SelectDays(props) {

    const [selectedDays, setSelectedDays] = useState([]);

    const updateOptions = (day) => {
        if (selectedDays.includes(day)) {
            setSelectedDays(selectedDays.filter((d) => d !== day));
        } else {
            setSelectedDays([...selectedDays, day]);
        }
    }

    let disable = selectedDays.length === 0;

    return (
        <div id="uo-select-days" className="uo-component">
            <div id="uo-sd-form" className="ou-with-text">
                <h4>What days do you prefer to exercise?</h4>

                <div id="uo-sd-f-days">
                    {
                        weekFull.map((day, index) => {
                            return <TextOptionTile key={index} label={day} onClick={updateOptions} isActive={selectedDays?.includes(day)} />
                        })
                    }
                </div>


                <CustomButton disabled={disable} className="uo-button active" onClick={() => {
                    props?.moveNext();
                    props?.setPreRegistrationDetails(prd => ({
                        ...prd,
                        daysToWorkout: selectedDays
                    }));
                }}>Continue</CustomButton>
            </div>
        </div>
    );
}

export default SelectDays;